// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api_url: 'https://leergut.gmeindl.net/api.ws'
  //api_url: 'http://192.168.13.108:8090/api.ws'
  //api_url: 'http://leergut.local/api.ws'
  //api_url: 'http://192.168.1.103:8080/api.ws'
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts